import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {NotificationService} from '../../../../../core/services/notification.service';
import { UserService } from '../../../../../core/services/user.service';
import { IOrderDetails } from '../../../models/order-details.model';
import { ConsolidateShipmentService } from '../../../../../core/services/consolidate-shipments.service';

@Component({
    selector: 'eci-consol-shipment-checkpoints-list',
    templateUrl: './consol-shipment-checkpoints-list.component.html',
    styleUrls: ['./consol-shipment-checkpoints-list.component.scss']
})
export class ConsolShipmentCheckpointsListComponent implements OnInit {

    @Input() info: IOrderDetails;
    @Input() isCreateMode: boolean = true;
    @Output() syncWithAfterShip = new EventEmitter<any>();

    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

    constructor(
        private dialog: MatDialog,
        public userSvc: UserService,
        private consolShipmentService: ConsolidateShipmentService,
        private notify: NotificationService,
    ) {
    }

    ngOnInit(): void {
        this.consolShipmentService.getConsolShipmentCheckpoints(this.info?.id).subscribe(values => {
            this.dataSource = new MatTableDataSource<any>(values);
            console.log(this.dataSource);
        }, error => {
            // this.notify.showError('Tracking details could not be retrieved because the slug field was not set');
        });
    }

    displayedColumns: string[] = [
        'checkpointDate',
        'location',
        'subStatus', // TODO MAYBE NEED TO CHANGE TO ENUM
        'message',
    ];

    syncWithAftership(): void {
        this.syncWithAfterShip.emit(this.info.id);
    }

    isAdmin() {
        return this.userSvc.isAdmin;
    }
}
